/* eslint-disable local-rules/no-euro-usage */
import { CurrencyEnum } from 'api/gen'
import { useAuthContext } from 'features/auth/context/AuthContext'
import { useLocation } from 'libs/location/location'
import { LocationMode } from 'libs/location/types'
import { getCurrencyFromParam } from 'shared/currency/getCurrencyParam'

export enum Currency {
  EURO = '€',
  PACIFIC_FRANC_SHORT = 'F',
  PACIFIC_FRANC_FULL = 'francs\u00a0Pacifique',
}

type CurrencyDisplayFormat = 'short' | 'full'

export const useGetCurrencyToDisplay = (
  displayFormat: CurrencyDisplayFormat = 'short'
): Currency => {
  const { user } = useAuthContext()
  const { selectedPlace, selectedLocationMode } = useLocation()

  const pacificFrancCurrency =
    displayFormat === 'full' ? Currency.PACIFIC_FRANC_FULL : Currency.PACIFIC_FRANC_SHORT

  const currencyParam = getCurrencyFromParam()
  if (currencyParam === CurrencyEnum.EUR) return Currency.EURO
  if (currencyParam === CurrencyEnum.XPF) return pacificFrancCurrency

  const isEverywhereLocationMode = selectedLocationMode === LocationMode.EVERYWHERE
  const isNotNewCaledonianLocationSelected = selectedPlace?.info !== 'Nouvelle-Calédonie'
  const isNewCaledonianLocationSelected = selectedPlace?.info === 'Nouvelle-Calédonie'

  if (selectedPlace) {
    if (isEverywhereLocationMode) return Currency.EURO
    if (isNotNewCaledonianLocationSelected) return Currency.EURO
    if (isNewCaledonianLocationSelected) return pacificFrancCurrency
  }

  const isUserRegisteredInEuroRegion = user?.currency === CurrencyEnum.EUR
  const isUserRegisteredInPacificFrancRegion = user?.currency === CurrencyEnum.XPF

  if (user) {
    if (isUserRegisteredInEuroRegion) return Currency.EURO
    if (isUserRegisteredInPacificFrancRegion) return pacificFrancCurrency
  }

  if (isEverywhereLocationMode) return Currency.EURO

  return Currency.EURO
}
